/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// common_groupstructure_GETROW
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import "./BranchToDcTsrDetailReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import { ReportRemoveSequenceChar, ReportUrl } from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebStockReportData,
  sWebStockReportArr,
  GetLocation,
  fValidationHead_Client,
  sWebBetweenReportArr,
} from "./BranchToDcTsrDetailReportAction";

// import { set } from 'date-fns/esm';

export default function BranchToDcTsrDetailReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  //Head

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fDate = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDate: e.target.value,
      sFromDate: new Date(),
      sToDate: new Date(),
    }));
  };
  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: e?.$d,
      }));
    }
  };

  const fReportType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sReportType: e.target.value,
    }));
  };
  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
  };

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const GetReportsView = async () => {
    // let xReportTypeTitle =
    //   HeadObject.sReportType == "PENDING"
    //     ? "Pending"
    //     : "PROGRESS"
    //     ? "Progress"
    //     : "HISTORY"
    //     ? "History"
    //     : "Pending Detail";
    let xType =
      HeadObject.sReportType == "PENDING"
        ? "P"
        : "PROGRESS"
        ? "G"
        : "HISTORY"
        ? "H"
        : "P";

    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";

    let ReportUrlObj = {
      UserCd: vRdxuserInfo.UserID,
      Date1: moment(HeadObject.sFromDate).format("MM-DD-YYYY"),
      Date2: moment(HeadObject.sToDate).format("MM-DD-YYYY"),
      LocCSV: HeadObject.sLocationPrnt,
      ReportType: HeadObject.sReportType,
      Type: xType,
    };
    console.log(ReportUrlObj);
    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    console.log(
      "sCurrentReport",
      urlPrint + "WMS/BranchToDCTSRDetail?" + sCurrentReport
    );
    setWebReportUrlModal(
      urlPrint + "WMS/BranchToDCTSRDetail?" + sCurrentReport
    );
    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;

    await GetReportsView();
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetLocation(setLocationData);
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div></div>
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                sWebStockReportData={sWebStockReportData}
                sWebStockReportArr={sWebStockReportArr}
                HeadObject={HeadObject}
                fLocation={fLocation}
                fFromDate={fFromDate}
                fToDate={fToDate}
                fDate={fDate}
                fReportType={fReportType}
                sWebBetweenReportArr={sWebBetweenReportArr}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
